import { createApi } from '@reduxjs/toolkit/query/react';
import { BULK_DOWNLOAD_REPORTS, CLASSROOM_REPORTS, FAVOURITE_REPORT, REPORTS_LISTING } from 'config/apiPaths';
import { generatePath } from 'react-router-dom';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"
import { downloadCenterApi } from './downloadCenter';

export const resourceApi = createApi({
    reducerPath: 'resourceApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/resource",
    }),
    tagTypes: ["Profile"],
    endpoints: (builder) => ({
        getReportsList: builder.query({
            query: ({ page = 1, limit = 10, status = "", grade = "", discipline = "", search = "", id = '', sort = { column: "id", direction: "DESC" } }) => ({
                method: "PATCH",
                url: `${REPORTS_LISTING}/${id}`,
                data: { page, limit, sort, search, status: status?.value, grade: grade?.value, discipline_id: discipline?.value }
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ReportListing"]
        }),

         getClassroomReportsList: builder.query({
            query: ({ page = 1, limit = 10, status = "", grade = "", school_id = "", search = "", id = '', sort = { column: "id", direction: "DESC" } }) => ({
                method: "PATCH",
                url: `${CLASSROOM_REPORTS}`,
                data: { page, limit, sort, search, status: status?.value, grade: grade?.value, school_id: school_id?.value }
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ClassroomReportListing"]
        }),

        favouriteReport: builder.mutation({
            query: ({ data, id }) => ({
                method: "PATCH",
                url: `${FAVOURITE_REPORT}/${id}`,
                data: data
            }),
            transformResponse: (response) => {
                return response;
            },
            invalidatesTags: ["ReportListing"]
        }),

        bulkDownloadReports: builder.mutation({
            query: ({ id }) => ({
                method: "POST",
                url: `${generatePath(BULK_DOWNLOAD_REPORTS, { school_id: id })}`,
            }),
            async onQueryStarted(id, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    dispatch(downloadCenterApi.util.invalidateTags(['BulkDownloadReports']));
                } catch (error) {
                    console.log('error', error)
                }
            },
            transformResponse: (response) => {
                return response;
            },
        }),
    }),
});

export const {
    useGetReportsListQuery,
    useFavouriteReportMutation,
    useBulkDownloadReportsMutation,
    useGetClassroomReportsListQuery
} = resourceApi;